/**
 * Shared rail steps for welcome / wizard / success (proto v2).
 */
import type { OnboardingRailStep } from './OnboardingBrandRail';
import type { OnboardingWizardStepId } from './onboardingWizardConfig';

const BASE_STEPS = [
  { key: '1', label: 'Qué vendés' },
  { key: '2', label: 'Nombre del local' },
  { key: '3', label: 'Listo para vender' },
] as const;

export function welcomeRailSteps(): OnboardingRailStep[] {
  return BASE_STEPS.map((s, i) => ({
    ...s,
    state: i === 0 ? 'on' : 'upcoming',
  }));
}

export function successRailSteps(): OnboardingRailStep[] {
  return BASE_STEPS.map((s) => ({
    ...s,
    state: 'done' as const,
  }));
}

/** Map wizard step id → which of the 3 rail slots is active. */
export function wizardRailSteps(
  currentId: OnboardingWizardStepId,
  options?: { otherRubro?: boolean },
): OnboardingRailStep[] {
  // other-rubro stays on slot 1 (detalle del rubro)
  const activeSlot =
    currentId === 'identity' ? 1 : currentId === 'business-type' || currentId === 'other-rubro' ? 0 : 0;

  if (options?.otherRubro && currentId === 'other-rubro') {
    return [
      { key: '✓', label: 'Qué vendés', state: 'done' },
      { key: '1', label: 'Detalle Otros', state: 'on' },
      { key: '2', label: 'Nombre del local', state: 'upcoming' },
    ];
  }

  return BASE_STEPS.map((s, i) => ({
    ...s,
    state: i < activeSlot ? 'done' : i === activeSlot ? 'on' : 'upcoming',
  }));
}

export function railCopyForWizardStep(
  currentId: OnboardingWizardStepId,
  options?: { otherRubro?: boolean },
): { title: string; subtitle: string; footer: string } {
  if (options?.otherRubro && currentId === 'other-rubro') {
    return {
      title: 'No está\nen la lista.',
      subtitle: 'Decinos qué vendés y cómo trabajás. Armamos el local y te escribimos si hace falta sumar el rubro.',
      footer: 'Paso 1 de 3',
    };
  }
  if (currentId === 'identity') {
    return {
      title: 'Nombre\ndel local',
      subtitle: 'Escribí cómo se llama tu local. Después lo podés cambiar.',
      footer: 'Paso 2 de 3',
    };
  }
  return {
    title: '¿Qué\nvendés?',
    subtitle: 'Elegí el que más se parece. Si no está, elegí Otros.',
    footer: 'Paso 1 de 3',
  };
}
